<div class="flex-fill d-flex flex-column">
    <div class="card">
        <div class="card-body" style="max-width: 1050px">
            <dx-form [formData]="filter" [colCount]="2" (onEditorEnterKey)="search()">
                <dxi-item itemType="group">
                    <dxi-item
                        dataField="dealerId"
                        editorType="dxSelectBox"
                        [label]="{ text: 'Dealer' }"
                        [editorOptions]="{ items: dealers, valueExpr: 'id', displayExpr: 'displayName' }"
                    ></dxi-item>
                    <dxi-item dataField="code"></dxi-item>
                    <dxi-item dataField="includeDeleted" editorType="dxCheckBox" [label]="{ text: 'Include Deleted' }"></dxi-item>
                </dxi-item>
            </dx-form>
            <div class="btn-toolbar justify-content-end align-items-center mt-3">
                <div *ngIf="confirmations" class="me-3">{{ confirmations.length }} {{ confirmations.length === 1 ? 'item found' : 'items found' }}</div>
                <button type="button" accesskey="s" (click)="search()" class="btn btn-primary">Search</button>
                <button type="button" (click)="clear()" class="btn btn-light ms-2">Clear</button>
            </div>
        </div>
    </div>
    <div *ngIf="confirmations" class="m-1 grid-fill">
        <dx-data-grid
            #dataGrid
            [dataSource]="confirmations"
            keyExpr="id"
            [columnAutoWidth]="false"
            [wordWrapEnabled]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onExporting)="onExporting($event)"
        >
            <dxi-column dataField="code" width="255" cellTemplate="codeTemplate"></dxi-column>
            <dxi-column dataField="invoiceNumber" caption="Sales Order #" width="80" cellTemplate="linkTemplate"></dxi-column>
            <dxi-column dataField="companyName" caption="Dealer" width="200" cellTemplate="dealerLinkTemplate"></dxi-column>
            <dxi-column dataField="typeName" caption="Type" width="100"></dxi-column>
            <dxi-column dataField="created" caption="Created" format="shortDateShortTime" dataType="date" width="100" [sortIndex]="0" sortOrder="desc"></dxi-column>
            <dxi-column dataField="viewed" dataType="date" format="shortDateShortTime" width="100"></dxi-column>
            <dxi-column dataField="approved" dataType="date" format="shortDateShortTime" width="100"></dxi-column>
            <dxi-column dataField="declined" dataType="date" format="shortDateShortTime" width="100"></dxi-column>
            <dxi-column dataField="confirmedBy" width="100"></dxi-column>
            <dxi-column dataField="confirmationPaymentMethodName" caption="Payment Method" width="100"></dxi-column>
            <dxi-column dataField="total" caption="Order Total" [format]="{ type: 'currency', precision: 2 }" width="100"></dxi-column>
            <dxi-column dataField="cancelReason" width="100"></dxi-column>
            <dxi-column dataField="notes" width="100"></dxi-column>
            <dxi-column dataField="requestedSalesRepContact" caption="Contact Dealer" width="100"></dxi-column>
            <dxi-column dataField="salesRepName" caption="Sales Rep" width="80"></dxi-column>
            <dxi-column dataField="acknowledged" dataType="date" format="shortDateShortTime" width="100"></dxi-column>
            <dxi-column dataField="acknowledgedBy" width="100"></dxi-column>
            <dxi-column dataField="message" width="400"></dxi-column>
            <dxi-column width="20"></dxi-column>

            <div *dxTemplate="let cell of 'linkTemplate'">
                <a [routerLink]="[]" (click)="open(cell.data.orderId)">{{ cell.value }}</a>
            </div>

            <div *dxTemplate="let cell of 'dealerLinkTemplate'">
                <a [routerLink]="['/dealers/overview/' + cell.data.dealerId]">{{ cell.value }}</a>
            </div>

            <div *dxTemplate="let cell of 'codeTemplate'">
                <a [routerLink]="[]" (click)="viewConfirmation(cell.data.code)">{{ cell.value }}</a>
            </div>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="confirmation-history-grid"></dxo-state-storing>
            <dxo-selection [mode]="'multiple'"></dxo-selection>

            <div *dxTemplate="let cell of 'vendorTemplate'">
                <a [routerLink]="['/vendors/overview/' + cell.data.vendorId]">{{ cell.value || '' }} </a>
            </div>

            <div *dxTemplate="let data of 'toolbarButtons'">
                <button class="btn btn-success" (click)="print(dataGrid.instance.getSelectedRowsData()[0])" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
                    Print
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="confirmations" class="me-3">
                    <strong>
                        {{ dataGrid.instance.totalCount() + ' items' }}
                        {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + ' selected' : '' }}
                    </strong>
                </span>
            </div>
        </dx-data-grid>
    </div>
</div>
